import {
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Button,
  useRecordContext,
} from "react-admin";
import { usePermissions } from "react-admin";
import { useState } from "react";
import PasswordUpdateDialog from "./PasswordUpdateDialog";
import { Box } from "@mui/material";

const UpdatePasswordButton = () => {
  const record = useRecordContext();
  const [open, setOpen] = useState(false);
  const { permissions } = usePermissions();

  if (!['admin', 'supervisor'].includes(permissions)) {
    return null;
  }

  return (
    <>
      <Button
        label="Update Password"
        onClick={() => setOpen(true)}
        color="primary"
        size="small"
      />
      <PasswordUpdateDialog
        open={open}
        onClose={() => setOpen(false)}
        record={record}
      />
    </>
  );
};


const UserTypeField = ({ source }) => {
  // Use the hook to get the current record
  const record = useRecordContext();

  console.log("UserTypeField - record from hook:", record);

  if (!record) {
    console.log("No record available");
    return null;
  }

  const type = record[source];
  console.log("UserTypeField - type:", type);

  // Map database types to display names
  const typeMap = {
    'farmer': 'مزارع (Farmer)',
    'buyer': 'مشتري (Buyer)',
    'cooperative': 'تعاونية (Cooperative)',
    'service_provider': 'شركة (Service Provider)',
    'marketer': 'Marketer',
    'supplier': 'Supplier',
  };

  // For cooperatives, show both type and cooperative type
  if (type === 'cooperative' && record.cooperativeType) {
    const cooperativeTypeMap = {
      'agriculture': 'زراعية إنتاجية',
      'consumer': 'إستهلاكية',
    };
    return (
      <Box>
        <div>{typeMap[type] || type}</div>
        <div style={{ fontSize: '0.875em', color: '#666' }}>
          {cooperativeTypeMap[record.cooperativeType] || record.cooperativeType}
        </div>
      </Box>
    );
  }

  return <span>{typeMap[type] || type || 'Unknown'}</span>;
};

export const UsersDataGrid = (props) => {
  // console.log("UsersDataGrid rendering with props:", props);
  return (
    <Datagrid
      className="mt-4"
      rowClick="edit"
      bulkActionButtons={<></>}
      sx={{
        "& .RaBulkActionsToolbar-toolbar": {
          display: "none",
        },
      }}
    >
      <TextField source="name" />
      <TextField source="phonenumber" />
      <UserTypeField source="type" />
      <TextField source="gender" />
      <DateField source="created_at" />
      <ReferenceField source="location" reference="state">
        <TextField source="name_en" />
      </ReferenceField>
      <ReferenceField source="locality" reference="locality">
        <TextField source="name_en" />
      </ReferenceField>
      <ReferenceArrayField reference="servicetypes" source="service_id">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <ReferenceArrayField reference="sub_category" source="subCategory_id">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      {/* <DateField source="dob" /> */}
      <UpdatePasswordButton />
    </Datagrid>
  );
};

export default UsersDataGrid;